// Prevod dinamičkih kolona (nazivi dolaze iz SP-a kao aliasi).
// Upotreba: header={translateCol(t, colMeta?.label || colKey)}
// Redosled: 1) eksplicitna COLUMN_I18N mapa (prettified/raw aliasi),
//           2) reverzni indeks iz sr.json (svaka vrednost -> ključ),
//           3) original (bezbedno, ako ništa ne odgovara).
import i18n from '../i18n';

export const COLUMN_I18N = {
  // ---- Agencijski nalozi (kolone prevoznika iz returnAllDataTrips) ----
  /* U agencijskom modulu kolona broja nosi alias 'Broj naloga' — to nije broj
     putnog naloga nego broj agencijskog, sa oznakom AN. */
  'Broj naloga': 'ture.brojAgencijskog',
  'Prevoznik': 'ture.prevoznik',
  'Vozilo prevoznika': 'ture.voziloPrevoznika',
  'Vozač prevoznika': 'ture.vozacPrevoznika',
  'Telefon prevoznika': 'ture.telefonPrevoznika',
  'Broj pasoša prevoznika': 'ture.brojPasosa',
  'Cena prevozniku': 'ture.cenaPrevozniku',
  'Valuta prevoznika': 'nova.valuta',
  'Rok plaćanja prevozniku': 'ture.rokPlacanjaPrevozniku',
  'Tip kamiona': 'ture.tipKamiona',
  'Odgovorno lice prevoznika': 'ture.odgovornoLice',

  // ---- Putni nalozi ----
  'Izaberi': 'nova.izaberi',
  'Broj putnog naloga': 'ture.brojPutnog',
  'Datum polaska': 'ture.datumPolaska',
  'Datum dolaska': 'ture.datumDolaska',
  'Relacija': 'nova.relacija',
  'Vozač': 'ture.vozac',
  'Registracija': 'ture.registracija',
  'Priključno vozilo': 'ture.prikljucnoVozilo',
  'Status ture': 'ture.statusTure',
  'Obračun ture': 'ture.obracunTure',
  'Napomena': 'nova.napomena',
  'Kreirao': 'ture.kreirao',
  'Poslednji izmenio': 'ture.poslednjiIzmenio',
  'Vreme unosa': 'ture.vremeUnosa',
  'Vreme izmene': 'ture.vremeIzmene',
  'Ostala vozila': 'ture.ostalaVozila',
  'Ostali vozači': 'ture.ostaliVozaci',
  'Potrošeno gorivo Vozila': 'ture.potrosenoGorivoVozila',
  'Potrošeno gorivo Termo': 'ture.potrosenoGorivoTermo',
  'Potrošen AdBlue': 'ture.potrosenAdBlue',
  'Početna KM Vozila': 'ture.pocetnaKMVozila',
  'Početna KM AdBlue': 'ture.pocetnaKMAdBlue',
  'Početni sati Termo': 'ture.pocetniSatiTermo',
  'Početno stanje goriva Vozila': 'ture.pocetnoGorivoVozila',
  'Početno stanje goriva Termo': 'ture.pocetnoGorivoTermo',
  'Početno stanje AdBlue': 'ture.pocetnoStanjeAdBlue',
  'Prosečna potrošnja Vozila': 'ture.prosecnaPotrosnjaVozila',
  'Razlika KM Vozila': 'ture.razlikaKMVozila',
  'Razlika KM AdBlue': 'ture.razlikaKMAdBlue',
  'Razlika sati Termo': 'ture.razlikaSatiTermo',
  'Završna KM Vozila': 'ture.zavrsnaKMVozila',
  'Završna KM AdBlue': 'ture.zavrsnaKMAdBlue',
  'Završni sati Termo': 'ture.zavrsniSatiTermo',
  'Završno stanje goriva Vozila': 'ture.zavrsnoGorivoVozila',
  'Završno stanje goriva Termo': 'ture.zavrsnoGorivoTermo',
  'Završno stanje AdBlue': 'ture.zavrsnoStanjeAdBlue',
  // ---- Radni nalozi ----
  'Broj radnog naloga': 'ture.brojRadnogNaloga',
  'Klijent': 'nova.klijent',
  'Utovari': 'ture.utovari',
  'Istovari': 'ture.istovari',
  'Cena': 'ture.cena',
  'Valuta': 'nova.valuta',
  'Kurs': 'nova.kurs',
  'Tip naloga': 'ture.tipNaloga',
  'Status radnog naloga': 'ture.statusRadnog',
  'Status šefa': 'nova.statusSefa',
  'Finansijski status': 'nova.finansijskiStatus',
  'Vozilo': 'nova.vozilo',
  'Rok plaćanja': 'ture.rokPlacanja',
  'Dodatni troškovi': 'ture.dodatniTroskovi',
  'Troškovi pregleda': 'ture.troskoviPregleda',
  'Izvozno carinjenje': 'ture.izvoznoCarinjenje',
  'Uvozno carinjenje': 'ture.uvoznoCarinjenje',
  'Granični prelaz': 'ture.granicniPrelaz',
  'Napomena granica': 'ture.napomenaGranica',
  'Napomena plaćanje': 'ture.napomenaPlacanje',
  'Napomena za vozača': 'ture.napomenaVozaca',
  'Spediter granica': 'ture.spediterGranica',
  'Spediter izvoz': 'ture.spediterIzvoz',
  'Spediter uvoz': 'ture.spediterUvoz',
  'Datum unosa': 'ture.datumUnosa',
  'Vozilo duži': 'ture.voziloDuzi',
  'Datum': 'nova.datum',
  'Iznos': 'nova.iznos',
  'Država': 'ture.drzava',
  'Kilometraža': 'ture.kilometraza',
  'Početna KM': 'ture.pocetnaKM',
  'Završna KM': 'ture.zavrsnaKM',
  // ---- Alarmi (Administracija → Alarmi): grupe + tipovi (ADR/LPaket/CODEXL identični svuda → fall-through) ----
  'Dodatna oprema': 'acol.grpDodatnaOprema',
  'Nabavka': 'acol.grpNabavka',
  'Saobraćajna': 'acol.grpSaobracajna',
  'Osiguranja': 'acol.grpOsiguranja',
  'Važni datumi': 'acol.grpVazniDatumi',
  'Lizing': 'acol.tLizing',
  'Istek garancije': 'acol.tIstekGarancije',
  'Istek saobraćajne': 'acol.tIstekSaobracajne',
  'AO osiguranje': 'acol.tAO',
  'Zeleni karton': 'acol.tZeleniKarton',
  'Osiguranja stakla': 'acol.tStaklo',
  'Strahovka osiguranje': 'acol.tStrahovka',
  'Kasko osiguranje': 'acol.tKasko',
  'CMR osiguranje': 'acol.tCMR',
  'Bela potvrda': 'acol.tBelaPotvrda',
  'TIR Sertifikat': 'acol.tTIR',
  'Šestomesečni': 'acol.tSestomesecni',
  'Taho sertifikat': 'acol.tTaho',
  'PP aparat': 'acol.tPPaparat',
  'Prva pomoć': 'acol.tPrvaPomoc',
  'FRC sertifikat': 'acol.tFRC',
  'FNX sertifikat': 'acol.tFNX',
  'Mapiranje': 'acol.tMapiranje',
  'Etaloniranje': 'acol.tEtaloniranje',
  'Vinjeta': 'acol.tVinjeta',
  /* Kolone pregleda vozila; 'Vinjete' se NE oslanja na obrnuti indeks jer je
     `admin.vinjete` verzal (naslov jezicka), pa se po vrednosti ne poklapa. */
  'Vinjete': 'acol.c_vinjete',
  'Vinjeta ističe': 'acol.c_vinjeta_istice',
  // ---- Alarmi vozača (dokumenti); CPC / CPC 1-5 identični → fall-through ----
  'Domaći dokumenti': 'acol.grpDomaciDok',
  'Strani dokumenti': 'acol.grpStraniDok',
  'Lična karta': 'acol.tLicnaKarta',
  'Vozačka dozvola': 'acol.tVozackaDozvola',
  'Tahograf kartica': 'acol.tTahografKartica',
  'Osiguranje': 'acol.tOsiguranje',
  'Lekarsko uverenje': 'acol.tLekarskoUverenje',
  'ADR sertifikat': 'acol.tADRSertifikat',
  'Bezbednost na radu': 'acol.tBezbednostNaRadu',
  'Pasoš': 'acol.tPasos',
  'Viza': 'acol.tViza',
  'Strana lična karta': 'acol.tStranaLicnaKarta',
  'Strana vozačka dozvola': 'acol.tStranaVozacka',
  'Strani pasoš': 'acol.tStraniPasos',
  'Strana viza': 'acol.tStranaViza',
};

let REV = null;
const buildRev = () => {
  REV = {};
  const bundle = i18n.getResourceBundle('sr', 'translation') || {};
  for (const ns of Object.keys(bundle)) {
    const obj = bundle[ns];
    if (obj && typeof obj === 'object') {
      for (const k of Object.keys(obj)) {
        const v = obj[k];
        if (typeof v === 'string' && !(v in REV)) REV[v] = ns + '.' + k;
      }
    }
  }
};

export const translateCol = (t, label) => {
  if (!label) return label;
  if (COLUMN_I18N[label]) return t(COLUMN_I18N[label]);
  if (!REV) buildRev();
  const key = REV[label];
  return key ? t(key) : label;
};
